export default __webpack_public_path__ + "static/media/iam_background_l2.0abdb06a.jpg";